import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import { getUserStationId, visibilitySettings } from '../../../utils';
import BackstageStationGridItem from '../../BackstageStationGridItem';

const ArtistRadioGridItemWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageConstants.BackstageSections.ARTIST_RADIO },
  visibilitySettings({ isGridComponent: true }),
)(BackstageStationGridItem);

const ArtistRadioGridItem = props => {
  const {
    pandoraId,
    userStationId,
    shareableUrlPath,
    isMobileDevice,
    imgUrl,
    isRightRailActive,
    isFirstSection,
  } = props;

  return (
    <D.ContentSection
      isFirstSection={isFirstSection}
      isArtistStation={true}
      title={<FormattedMessage {...BackstageConstants.messages.artistRadio} />}
    >
      <D.AppContextIntegrationData
        data={{
          contentSection: BackstageConstants.BackstageSections.ARTIST_RADIO,
          pandoraId: userStationId,
        }}
      >
        <ArtistRadioGridItemWithLogger
          id={userStationId}
          pandoraId={pandoraId}
          isMobileWeb={isMobileDevice}
          pageUrl={shareableUrlPath}
          imgUrl={imgUrl}
          twoColumns={!isRightRailActive}
          isFluid={true}
        />
      </D.AppContextIntegrationData>
    </D.ContentSection>
  );
};

ArtistRadioGridItem.propTypes = {
  pandoraId: PropTypes.string,
  userStationId: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  isFirstSection: PropTypes.bool,
  imgUrl: PropTypes.string,
};

export function mapStateToProps(state, ownProps) {
  const { pandoraId } = ownProps;
  const details = D.getInDomain('catalog.utils.getCatalogDetailsFromState')(state, pandoraId);

  return {
    imgUrl: D.getHero(
      state,
      details,
      D.Constants.Grid.GridConstants.GRID_ITEM_IMAGE_SIZE,
      D.Constants.SourceTypes.PandoraTypes.ARTIST,
    ),
    userStationId: getUserStationId(state, pandoraId),
  };
}

export default connect(mapStateToProps)(ArtistRadioGridItem);
